// @flow
import styled from 'styled-components';

export const Container = styled.div`
    margin: 0 1em;
    position: relative;
`;

export const MenuItem = styled.div`
    color: ${props => (props.active ? props.theme.mainBrandColor : props.theme.linkColor)};
    cursor: pointer;
    display: inline-block;
    font-size: 1em;
    text-align: center;
    text-transform: capitalize;
    width: ${({ itemsTotal }) => `${100 / itemsTotal}%`};
    &:after {
        content: '';
        display: block;
        height: 1.2em;
        margin-left: ${({ itemIsFirst }) => (itemIsFirst ? '50%' : '0')};
        width: ${({ itemIsFirst, itemIsLast }) => (itemIsFirst || itemIsLast ? '50%' : '100%')};
        border-bottom: ${({ theme }) => `1px dotted ${theme.mediumGrey}`};
    }
`;

export const ActiveBarContainer = styled.div`
    position: absolute;
    bottom: -0.1em;
    left: 0;
    transition: transform 0.5s ease;
    transform: ${({ selectedIndex }) => `translate3d(${selectedIndex}00%, 0, 0)`};
    width: ${({ itemsTotal }) => `${100 / itemsTotal}%`};
`;

export const ActiveBar = styled.div`
    position: relative;
    width: 3.75em;
    height: 0.3125em;
    background-color: ${({ theme }) => theme.mainBrandColor};
    border-radius: 0.3125em;
    margin-left: calc(50% - 1.875em);

    &::after {
        content: ' ';
        position: absolute;
        bottom: 0.3125em;
        left: 50%;
        margin-left: -0.15625em;
        border-left: 0.3125em solid transparent;
        border-right: 0.3125em solid transparent;
        border-bottom: 0.25em solid ${({ theme }) => theme.mainBrandColor};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-switch/styles.js